<template>
    <div>
        <banner :defaultMenu="0"></banner>
        <yindao></yindao>

        <beian></beian>
    </div>
</template>
<script>
import banner   from    '@/components/banner'
import  beian   from    '@/components/beian.vue'
import yindao   from    './components/yindao'
export default {
    components: {
        banner,          //顶部菜单+导航栏
        yindao,
        beian
    },
    data() {
        return {
        }
    },
    created(){
        this.$redirectByDevice()            //pc/移动端自动跳转
    }
}
</script>
<style scoped lang="less">
</style>